<template>
<ul class="addresses-list-component":class="{ 'addresses-list-component--hide-items-buttons': hideItemsButtons }">
  <template v-if="addresses.length > 0">
    <li v-for="a of addresses" :key="a.id" class="addresses-list-component__item">
      <router-link :to="{ name: 'addresses.edit', params: { id: a.id } }"
                   class="addresses-list-component__item-link"
                   :replace="!!$route.params.id"
      >
        <h5 class="addresses-list-component__item-title">{{ a.name || 'Без названия' }}</h5>
        <p class="addresses-list-component__item-text">{{ addressToString(a) }}</p>
      </router-link>
      <div v-if="!hideItemsButtons" class="addresses-list-component__buttons">
        <button @click="deleteAddress(a.id)" type="button">Удалить</button>
      </div>
    </li>
  </template>
  <li v-else class="addresses-list-component__item">
    <p class="p-5">Нет сохранённых адресов</p>
  </li>
  <li class="addresses-list-component__item addresses-list-component__item--new-address">
    <router-link :to="{ name: 'addresses.create' }" class="addresses-list-component__item-link">
      + Добавить
    </router-link>
  </li>
</ul>
</template>

<script>
import addressToString from '@/helpers/addressToString';
import deleteAddress from './deleteAddress';

export default {
  props: {
    addresses: {
      required: true,
      type: Array,
    },

    hideItemsButtons: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    addressToString,

    async deleteAddress(id) {
      await deleteAddress(id, this.$store);
      await this.$store.dispatch('savedAddresses/load', this.$store.state.auth.token);
    },
  },
};
</script>

<style lang="less">
@import '../../../pages/profile/common.less';

@r: addresses-list-component;
.@{r} {
  @item-padding-x: theme('padding.5');
  @buttons-font: theme('fontSize.sm');
  @buttons-line-height: theme('lineHeight.none');
  @buttons-padding-y: theme('padding.1');
  @buttons-margin-y: theme('margin.2');
  @buttons-height: calc(@buttons-font * @buttons-line-height + 2 * @buttons-padding-y + 2 * @buttons-margin-y);
  &__item {
    @apply relative;
    > * {
      @apply relative;
    }
    &:not(:first-child) {
      @apply border-t;
    }
  }
  @item-link-py: theme('padding.1');
  &__item-link {
    .profile__list-item-link();
    @apply block py-1;
    padding-right: @item-padding-x;
    padding-left: @item-padding-x;
    padding-bottom: calc(@item-link-py + @buttons-height);
  }
  &--hide-items-buttons {
    .@{r}__item-link {
      padding-bottom: @item-link-py;
    }
  }
  &__item-title {
    @apply my-2 text-sm font-bold;
  }
  &__item-text {
    @apply my-2;
  }
  &__buttons {
    @buttons-padding-x: theme('padding.1');
    @apply absolute bottom-0;
    margin-top: @buttons-margin-y;
    margin-bottom: @buttons-margin-y;
    margin-left: calc(@item-padding-x - @buttons-padding-x);
    margin-right: calc(@item-padding-x - @buttons-padding-x);
    > * {
      @apply text-primary;
      padding-left: @buttons-padding-x;
      padding-right: @buttons-padding-x;
      padding-top: @buttons-padding-y;
      padding-bottom: @buttons-padding-y;
      &:not(:first-child) {
        @apply ml-1;
      }
    }
  }
  &__item--new-address {
    .addresses-list-component__item-link {
      min-height: theme('height.16');
      @apply p-0 flex text-primary font-medium items-center justify-center;
    }
  }
}
</style>
